export class BaseApexApiResponse<T = string> {
    status: StatusApexResponse;
    result: T;
    errorMessage?: string;
    constructor(status: StatusApexResponse = StatusApexResponse.Failed) {
        this.status = status;
    }
}

export enum StatusApexResponse {
    Success = 'OK',
    Failed = 'KO',
}
